'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { combineReducers } from 'redux';
import javaScriptLinter from './JavaScriptLinter';
const reducers = combineReducers({
  javaScriptLinter
});

let _state = SeamlessImmutable({});

export default ((state, action) => {
  _state = SeamlessImmutable.merge(_state, reducers(state, action));
  return _state;
});